import SellersService from "@/api/services/sellers";
import { toCamelCase } from "@estaly/store/src/utils/utils";

const initialState = {
  index: [],
  totalPages: null,
  totalCount: null,
};

export default {
  namespaced: true,
  state: initialState,
  getters: {},
  mutations: {
    setIndex(state, data) {
      state.index = data.sellers;
      state.totalPages = data.page.totalPages || 0;
      state.totalCount = data.page.totalCount || 0;
    },
  },
  actions: {
    async update(_, { id, data }) {
      return await SellersService.update(id, data);
    },
    async delete(_, { id }) {
      return await SellersService.delete(id);
    },
    async fetchIndex({ commit }, { storeId, keywords, page = 1, perPage = null }) {
      const response = await SellersService.fetchIndex({ storeId, keywords, page, perPage });
      if (!response?.success) return response;

      const data = toCamelCase(response.data);
      commit("setIndex", data);

      return response;
    },
    setIndex(state, data) {
      state.index = data.sellers;
      state.totalPages = data.page.totalPages || 0;
      state.totalCount = data.page.totalCount || 0;
    },
    async getRanking(_, params) {
      return await SellersService.getRanking(params);
    },
  },
};
